const templates = {};

const get = (templateName) => ( templates[templateName] )

export default { get };
